angular.module('invoice')
    .component('invoiceProjectBudgetAnalysis', {
        bindings: {
            projectId: '<'
        },
        templateUrl: 'app/invoice/invoice-project/budget-analysis/budget-analysis.html',
        controller: function ($timeout, $window, InvoiceProjectBudgetAnalysis, InvoiceService, Principal) {
            const realizationStartStatus = 'ACCOUNTING_APPROVING'
            const scrollHistoryStateKey = 'invoiceProjectBudgetAnalysisScroll'
            const companyFilterHistoryStateKey = 'invoiceProjectBudgetAnalysisCompanyFilter'
            const supportedCompanyFilters = ['external', 'internal']
            const amountFields = [
                'projectBgt',
                'agreementBgt',
                'agreementWithoutBgt',
                'agreementTotalBgt',
                'agreementRealization',
                'agreementRemaining',
                'orderBgt',
                'orderWithoutBgt',
                'orderTotalBgt',
                'orderRealization',
                'orderRemaining',
                'withoutAgreementOrOrderRealization',
                'withoutBgtWithoutAgreementOrOrderRealization',
                'withoutAgreementOrOrderTotalRealization',
                'totalRealization',
                'projectRemaining'
            ]

            this.items = null
            this.sections = []
            this.loading = false
            this.showRemaining = false
            this.showCents = false
            this.showZeros = false
            this.showExecutionPercentage = true
            this.allGroupsExpanded = true
            const savedCompanyFilter = $window.history.state && Object.prototype.hasOwnProperty.call($window.history.state, companyFilterHistoryStateKey) ? $window.history.state[companyFilterHistoryStateKey] : undefined
            this.customFilter = savedCompanyFilter === null || supportedCompanyFilters.includes(savedCompanyFilter) ? savedCompanyFilter : 'external'
            this.canEditPlanning = Principal.hasAnyAuthority(['ROLE_INVOICE_PROJECT_BGT_ANALYSIS_WRITE', 'ROLE_ADMIN'])
            this.canOpenAgreementLists = Principal.hasAnyAuthority(['ROLE_CONTRACT_MODULE', 'ROLE_ADMIN'])
            this.canOpenInvoiceList = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_BGT_READ', 'ROLE_INVOICE_DOCUMENTS_BGT_WRITE_WITH_READ_ACCESS', 'ROLE_ADMIN'])
            this.realizationStatuses = []

            InvoiceService.workflow.load().then(configuration => {
                const startIndex = configuration.statuses.indexOf(realizationStartStatus)
                this.realizationStatuses = startIndex < 0 ? [] : configuration.statuses.slice(startIndex)
            })

            this.$onChanges = changes => {
                if (changes.projectId && this.projectId != null) {
                    this.load()
                }
            }

            this.load = () => {
                const projectId = this.projectId
                const customFilter = this.customFilter
                const request = {projectId: projectId, customFilter: customFilter}
                this.currentRequest = request
                this.loading = true
                this.items = null
                this.sections = []
                return InvoiceProjectBudgetAnalysis.query({projectId: projectId, customFilter: customFilter}).$promise
                    .then(items => {
                        if (this.currentRequest === request) {
                            this.items = items
                            this.sections = groupByCurrency(items)
                            this.allGroupsExpanded = true
                        }
                    })
                    .finally(() => {
                        if (this.currentRequest === request) {
                            this.loading = false
                            restoreScrollPosition(projectId)
                        }
                    })
            }

            this.changeCompanyFilter = () => {
                const historyState = angular.extend({}, $window.history.state || {})
                historyState[companyFilterHistoryStateKey] = this.customFilter || null
                $window.history.replaceState(historyState, $window.document.title, $window.location.href)
                this.load()
            }

            this.rememberScrollPosition = () => {
                const historyState = angular.extend({}, $window.history.state || {})
                historyState[scrollHistoryStateKey] = {projectId: this.projectId, top: $window.scrollY || $window.pageYOffset || 0}
                $window.history.replaceState(historyState, $window.document.title, $window.location.href)
            }

            const restoreScrollPosition = projectId => {
                const scrollPosition = $window.history.state && $window.history.state[scrollHistoryStateKey]
                if (scrollPosition && scrollPosition.projectId === projectId) {
                    $timeout(() => $window.scrollTo(0, scrollPosition.top), 0, false)
                }
            }

            const groupByCurrency = items => {
                const sections = []
                const byCurrency = Object.create(null)
                angular.forEach(items, item => {
                    item.agreementTotalBgt = InvoiceService.add(item.agreementBgt || 0, item.agreementWithoutBgt || 0)
                    item.orderTotalBgt = InvoiceService.add(item.orderBgt || 0, item.orderWithoutBgt || 0)
                    item.withoutAgreementOrOrderTotalRealization = InvoiceService.add(item.withoutAgreementOrOrderRealization || 0, item.withoutBgtWithoutAgreementOrOrderRealization || 0)
                    const key = item.currency == null ? '__NO_CURRENCY__' : item.currency
                    let section = byCurrency[key]
                    if (section == null) {
                        section = {
                            key: key,
                            currency: item.currency,
                            currencyLabel: item.currency || 'Brak waluty',
                            groups: [],
                            groupsByKey: Object.create(null),
                            summary: emptySummary()
                        }
                        byCurrency[key] = section
                        sections.push(section)
                    }
                    const groupKey = item.parentGroupId != null ? item.parentGroupId : item.groupId
                    const normalizedGroupKey = groupKey == null ? '__NO_GROUP__' : groupKey
                    let group = section.groupsByKey[normalizedGroupKey]
                    if (group == null) {
                        group = {
                            key: normalizedGroupKey,
                            name: item.parentGroupName || item.groupName,
                            type: item.parentGroupType || item.groupType,
                            missingBgt: item.missingBgt === true,
                            expanded: true,
                            rootRow: null,
                            rows: [],
                            summary: emptySummary()
                        }
                        section.groupsByKey[normalizedGroupKey] = group
                        section.groups.push(group)
                    }
                    if (item.parentGroupId != null) {
                        group.rows.push(item)
                    } else {
                        group.rootRow = item
                    }
                    addToSummary(group.summary, item)
                    addToSummary(section.summary, item)
                })
                angular.forEach(sections, section => {
                    section.summary.realizationPercentage = InvoiceService.percentage(section.summary.totalRealization, section.summary.projectBgt) || 0
                    section.groups = section.groups.filter(group => group.missingBgt).concat(section.groups.filter(group => !group.missingBgt))
                    angular.forEach(section.groups, group => {
                        group.rows = mergeRelatedRows(group.rows, group.rootRow)
                        group.missingProjectBgt = group.rows.some(row => !row.projectBgtDefined)
                        group.warningTooltip = group.missingBgt ? 'Dokumenty nie zawierają BGT. Kwoty wyliczono zastępczo z wartości umów, zleceń lub kosztów DF.' : (group.missingProjectBgt ? 'Dla pozycji oznaczonych poniżej nie określono BGT w kosztorysie projektu.' : null)
                        group.summary.realizationPercentage = InvoiceService.percentage(group.summary.totalRealization, group.summary.projectBgt) || 0
                        delete group.rootRow
                    })
                    recalculatePlanningSummaries(section)
                    delete section.groupsByKey
                })
                if (sections.length === 0) {
                    sections.push({key: '__EMPTY__', empty: true, groups: []})
                }
                return sections
            }

            this.toggleGroup = group => {
                group.expanded = !group.expanded
                updateAllGroupsExpanded()
            }

            this.toggleAllGroups = () => {
                const expanded = !this.allGroupsExpanded
                angular.forEach(this.sections, section => angular.forEach(section.groups, group => group.expanded = expanded))
                this.allGroupsExpanded = expanded
            }

            this.markPlanningDirty = (row, section) => {
                row.planningChangeVersion = (row.planningChangeVersion || 0) + 1
                row.planningDirty = true
                row.planningSaveState = 'pending'
                recalculatePlanningSummaries(section)
                schedulePlanningSave(row, section, this.projectId)
            }

            this.startPlanningEdit = row => row.planningEditing = true

            this.finishPlanningEdit = row => row.planningEditing = false

            const schedulePlanningSave = (row, section, projectId) => {
                if (row.planningSaveTimeout != null) {
                    $timeout.cancel(row.planningSaveTimeout)
                }
                row.planningSaveTimeout = $timeout(() => {
                    row.planningSaveTimeout = null
                    savePlanning(row, section, projectId)
                }, 700)
            }

            const savePlanning = (row, section, projectId) => {
                if (!row.planningEditable || section.currency == null) {
                    return
                }
                if (row.planningSaving) {
                    row.planningSaveQueued = true
                    return
                }
                const savedChangeVersion = row.planningChangeVersion
                row.planningSaving = true
                row.planningSaveQueued = false
                row.planningSaveState = 'saving'
                return InvoiceProjectBudgetAnalysis.savePlanning({projectId: projectId}, {
                    groupId: row.planningGroupId,
                    currency: section.currency,
                    plannedContractAmount: row.plannedContractAmount,
                    engineerDescription: row.engineerDescription,
                    version: row.planningVersion
                }).$promise.then(saved => {
                    row.planningId = saved.id
                    row.planningVersion = saved.version
                    row.planningUpdatedTime = saved.updatedTime
                    row.planningUpdatedBy = saved.updatedBy
                    if (row.planningChangeVersion === savedChangeVersion) {
                        row.plannedContractAmount = saved.plannedContractAmount
                        row.engineerDescription = saved.engineerDescription
                        row.planningDirty = false
                        row.planningSaveState = 'saved'
                        const savedPlanningVersion = saved.version
                        $timeout(() => {
                            if (row.planningSaveState === 'saved' && !row.planningDirty && row.planningVersion === savedPlanningVersion) {
                                row.planningSaveState = null
                            }
                        }, 1600)
                    } else {
                        row.planningDirty = true
                        row.planningSaveState = 'pending'
                    }
                    recalculatePlanningSummaries(section)
                }).catch(() => {
                    row.planningDirty = true
                    row.planningSaveState = 'error'
                }).finally(() => {
                    row.planningSaving = false
                    if (row.planningSaveQueued || (row.planningDirty && row.planningChangeVersion !== savedChangeVersion)) {
                        schedulePlanningSave(row, section, projectId)
                    }
                })
            }

            const updateAllGroupsExpanded = () => {
                let allExpanded = true
                angular.forEach(this.sections, section => angular.forEach(section.groups, group => allExpanded = allExpanded && group.expanded))
                this.allGroupsExpanded = allExpanded
            }

            const mergeRelatedRows = (rows, rootRow) => {
                const mergedRows = rows.map(row => copyRow(row))
                if (rootRow != null) {
                    const relatedRows = mergedRows.filter(row => row.parentGroupId === rootRow.groupId && normalizedName(row.groupName) === normalizedName(rootRow.groupName))
                    if (relatedRows.length === 1) {
                        const relatedRow = relatedRows[0]
                        const relatedRowProjectBgtDefined = relatedRow.projectBgtDefined
                        addRowAmounts(relatedRow, rootRow)
                        relatedRow.projectBgtDefined = relatedRowProjectBgtDefined || rootRow.projectBgtDefined === true || Number(rootRow.projectBgt || 0) !== 0
                        relatedRow.groupIds.push(rootRow.groupId)
                        if (relatedRow.planningId == null && rootRow.planningId != null) {
                            copyPlanning(relatedRow, rootRow)
                            relatedRow.planningGroupId = rootRow.groupId
                        } else if (relatedRow.planningId == null && !relatedRowProjectBgtDefined && (rootRow.projectBgtDefined === true || Number(rootRow.projectBgt || 0) !== 0)) {
                            relatedRow.planningGroupId = rootRow.groupId
                        }
                    } else {
                        mergedRows.push(copyRow(rootRow))
                    }
                }
                angular.forEach(mergedRows, row => {
                    row.realizationPercentage = InvoiceService.percentage(row.totalRealization, row.projectBgt) || 0
                    row.planningEditable = row.planningGroupId != null && row.planningGroupId > 0 && row.missingBgt !== true
                })
                return mergedRows
            }

            const copyRow = row => {
                const copy = angular.copy(row)
                copy.displayKey = row.groupId == null ? '__NO_GROUP__' : 'group-' + row.groupId
                copy.groupIds = row.groupId == null ? [] : [row.groupId]
                copy.planningGroupId = row.groupId
                copy.planningChangeVersion = 0
                copy.projectBgtDefined = row.projectBgtDefined === true || Number(row.projectBgt || 0) !== 0
                return copy
            }

            const copyPlanning = (target, source) => {
                target.planningId = source.planningId
                target.planningVersion = source.planningVersion
                target.plannedContractAmount = source.plannedContractAmount
                target.engineerDescription = source.engineerDescription
                target.planningUpdatedTime = source.planningUpdatedTime
                target.planningUpdatedBy = source.planningUpdatedBy
            }

            const addRowAmounts = (target, source) => angular.forEach(amountFields, field => {
                target[field] = InvoiceService.add(target[field] || 0, source[field] || 0)
            })

            const normalizedName = name => name == null ? '' : name.trim().toLocaleLowerCase()

            const emptySummary = () => amountFields.reduce((summary, field) => {
                summary[field] = 0
                return summary
            }, {})

            const addToSummary = (summary, row) => angular.forEach(amountFields, field => {
                summary[field] = InvoiceService.add(summary[field], row[field] || 0)
            })

            const recalculatePlanningSummaries = section => {
                section.summary.plannedContractAmount = 0
                angular.forEach(section.groups, group => {
                    group.summary.plannedContractAmount = 0
                    angular.forEach(group.rows, row => {
                        group.summary.plannedContractAmount = InvoiceService.add(group.summary.plannedContractAmount, row.plannedContractAmount || 0)
                        calculatePlanSummary(row)
                    })
                    calculatePlanSummary(group.summary)
                    section.summary.plannedContractAmount = InvoiceService.add(section.summary.plannedContractAmount, group.summary.plannedContractAmount)
                })
                calculatePlanSummary(section.summary)
            }

            const calculatePlanSummary = target => {
                target.planTotal = InvoiceService.add(target.totalRealization || 0, target.plannedContractAmount || 0)
                target.planPercentage = InvoiceService.percentage(target.planTotal, target.projectBgt) || 0
            }
        }
    })
